import styled from 'styled-components';
import { TextButton } from '@oneaudi/unified-web-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const Container = styled.div`
  font-family: Audi Type;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0px auto;
  padding: ${SIZING.unit(4.5)} ${SIZING.unit(8)} ${SIZING.unit(4.5)} ${SIZING.unit(6.5)}; // 36, 81, 36, 52
  .margin-bottom-spacing {
    margin-bottom: ${SIZING.unit(12.5)};
  }

  @media ${device.tablet} {
    padding: ${SIZING.unit(4.5)} ${SIZING.unit(6)} ${SIZING.unit(4.5)} ${SIZING.unit(4.5)};
  }
`;

export const HeaderImage = styled.div`
  height: 165px;
  width: 100%;
  background-image: url(${(props: { src: string }) => props.src});
  background-size: cover;
  margin-bottom: ${SIZING.unit(4.5)};
  background-position-y: center;
  @media ${device.mobileL} {
    height: 205px;
  }
  @media ${device.tablet} {
    height: 305px;
  }
`;

export const Title = styled.h2`
  font-family: Audi Type Extended;
  font-size: 20px;
  letter-spacing: 0.0001em;
  color: ${COLORS.grey80};
  line-height: 32px;
  font-weight: 700;
`;

export const H3 = styled.h3`
  font-size: 16px;
  color: ${COLORS.grey80};
  margin-top: ${SIZING.unit(2)};
  line-height: 24px;
  font-weight: 700;
`;

export const Description = styled.p`
  font-size: 16px;
  color: ${COLORS.grey80};
  margin-top: ${SIZING.unit(1)};
  line-height: 24px;
  padding-left: ${SIZING.unit(2)};
`;

export const ContinueButton = styled(TextButton)`
  margin-top: ${SIZING.unit(4.5)};
  font-weight: 500;
  line-height: 24px;
  background-color: ${COLORS.black} !important;
  color: ${COLORS.white} !important;
  align-self: flex-end;
`;

export const Legal = styled.p`
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  margin-top: ${SIZING.unit(4.5)};
  color: ${COLORS.grey60};
  a {
    color: ${COLORS.grey60};
    text-decoration: underline;
  }
`;
